import React, { useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useTranslation } from "react-i18next";
import "../i18n";
import Alert from "../components/common/Alert";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert] = useState({ visible: false, type: "success", message: "" });
  const { t, i18n } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 600));
      setAlert({ visible: true, type: "success", message: t("ContactSuccess") });
      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      setAlert({ visible: true, type: "error", message: t("ContactError") });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header isHomePage={false} />
      {/* Hero Section - Discover sayfası ile hizalı */}
      <section className="relative w-full h-[220px] sm:h-[220px] md:h-[440px] lg:h-[440px] overflow-hidden ">
        <div className="absolute inset-0 ">
          <img
            src="/assets/allfriends.png"
            alt="İletişim"
            className="w-full h-full object-cover object-center"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 flex items-end  ">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 pb-4 sm:pb-8 md:pb-12 lg:pb-16  lg:px-10 xl:px-28">
            <h2 className=" text-3xl md:text-[42px] font-bold font-poppins sm:text-3xl md:text-4xl lg:text-[54px]    text-white text-start  sm:text-left max-w-xs sm:max-w-sm md:max-w-2xl mx-auto sm:mx-0">
            {t("ContactTitle")}
            </h2>
          </div>
        </div>
      </section>

      <div className="flex-1 text-black pb-16 px-4 md:px-8 lg:px-16">
        <Alert
          isVisible={alert.visible}
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ ...alert, visible: false })}
        />

        <div className="max-w-4xl mx-auto">

          <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 md:p-8 my-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm text-gray-700 mb-2">{t("ContactName")}</label>
                <input
                  type="text"
                  className="w-full p-3 border bg-white border-gray-300 rounded-lg text-black"
                  placeholder={t("ContactNamePlaceholder")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  disabled={submitting}
                />
              </div>
              <div>
                <label className="block text-sm text-gray-700 mb-2">{t("ContactEmail")}</label>
                <input
                  type="email"
                  className="w-full p-3 border bg-white border-gray-300 rounded-lg text-black"
                  placeholder={t("ContactEmailPlaceholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={submitting}
                />
              </div>
              <div>
                <label className="block text-sm text-gray-700 mb-2">{t("ContactMessage")}</label>
                <textarea
                  rows="5"
                  className="w-full p-3 border bg-white border-gray-300 rounded-lg text-black resize-y"
                  placeholder={t("ContactMessagePlaceholder")}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  disabled={submitting}
                />
              </div>
              <div className="pt-2">
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full md:w-auto px-8 py-3 rounded-full text-white font-semibold bg-gradient-to-r from-[#BC1D8F] to-[#FF3F59] hover:opacity-95 disabled:opacity-70"
                >
                  {submitting ? t("ContactSending") : t("ContactSend")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer isHomePage={false} />
    </div>
  );
};

export default Contact;


